export const invoiceReportConfig = {
  api: () => '/invoiceJobs/reports',
  title: 'Invoice Report',
  isActionTab: false,
  moreActions: [
    {
      name: 'View PDF',
      action: 'invoice',
      getKey: (value) => value.invoiceFile,
    },
  ],
  maskClosable: false,
  modalTitle: (action) => action + ' Invoice',
  getColumns: () => {
    return [
      {
        title: 'Client Name',
        dataIndex: 'clientName',
        key: 'clientName',
        type: 'renderHtml',
        render: (text) => {
          return text == 'Total'
            ? '<b style="color: #3b618f !important">Total</b>'
            : text;
        },
      },
      {
        title: 'Company Name',
        dataIndex: 'company',
        key: 'company',
        type: 'renderHtml',
        render: (text) => {
          return text == 'AG'
            ? `<b style="color: #3b618f !important">${text}</b>`
            : text;
        },
      },
      {
        title: 'Project Name',
        dataIndex: 'name',
        key: 'name',
        type: 'renderHtml',
        render: (text) => {
          return text == 'Total Amount'
            ? `<b style="color: #3b618f !important">${text}</b>`
            : text;
        },
      },
      {
        title: 'Total Amount',
        dataIndex: 'price',
        key: 'price',
        type: 'renderHtml',
        render: (text) => {
          return text != '0.00'
            ? `<b style="color: #3b618f !important">${text}</b>`
            : text;
        },
      },
      {
        title: 'GST Amount',
        dataIndex: 'GST',
        key: 'GST',
        type: 'renderHtml',
        render: (text) => {
          return text != '0.00'
            ? `<b style="color: #3b618f !important">${text}</b>`
            : text;
        },
      },
      {
        title: 'TDS Amount',
        dataIndex: 'tds',
        key: 'tds',
        type: 'renderHtml',
        render: (text) => {
          return text != '0.00'
            ? `<b style="color: #3b618f !important">${text}</b>`
            : text;
        },
      },
      {
        title: 'Net Amount',
        dataIndex: 'netAmount',
        key: 'netAmount',
        type: 'renderHtml',
        render: (text) => {
          return text != '0.00'
            ? `<b style="color: #3b618f !important">${text}</b>`
            : text;
        },
      },
    ];
  },
  getFormColumns: () => {
    return [];
  },
  combo: [],
  getData: () => ({}),
  actions: [
    { name: 'Search', isFilter: true, date: true },
    { name: 'Return', isBack: true, settings: { type: 'primary' } },
  ],
};
